<template>
  <div class="chart-wrapper">
    <rounded-elsa-pentagon
    :score="score"
    :chart_size="chart_size"
    :border_radius="border_radius"
    class="elsa-chart"
    />
  </div>
</template>

<script>
  import RoundedElsaPentagon from './raw/RoundedElsaPenta'
  export default {
    components: {
      RoundedElsaPentagon
    },
    props: {
      score: {
        type: Object,
        default: () => ({}),
      },
      chart_size: {
        type: Number,
        default: () => {return 300;}
      },
      border_radius: {
        type: Number,
        default: () => {return 4;}
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss" scoped>
.elsa-chart {
  margin-top: auto;
  margin-bottom: auto;
}

.chart-wrapper {
  align-items: center;
  height: 350px;
  display: flex;
  flex-direction: column;
}
</style>
